module.exports = __webpack_public_path__ + "media/22zl.e31393a9.mp3";